module.exports = __webpack_public_path__ + "static/media/VectorPointAndamento9.88668823.svg";